export default "__VITE_ASSET__6ee845f2__"